import styled from '@emotion/styled'

import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import ResultCard from './ResultCard'

import data from './data'

interface ResultProps {
  collectScore: number
  synthesizeScore: number
  actScore: number
  adaptScore: number
}

const Results: FC<ResultProps> = ({ collectScore, synthesizeScore, actScore, adaptScore }) => {
  const { collect, synthesize, act, adapt } = data
  const collectInfo = collect.levels[collectScore]
  const synthesizeInfo = synthesize.levels[synthesizeScore]
  const actInfo = act.levels[actScore]
  const adaptInfo = adapt.levels[adaptScore]

  return (
    <Wrapper>
      <StyledSection variant="noCopy">
        <Section.Contents>
          <Grid columns={1} overrides={{ md: 2, xl: 4 }}>
            <ResultCard
              score={collectScore}
              title={collect.title}
              rating={collectInfo.title}
              summary={collectInfo.summary}
              list={collectInfo.recommendations}
            />
            <ResultCard
              score={synthesizeScore}
              title={synthesize.title}
              rating={synthesizeInfo.title}
              summary={synthesizeInfo.summary}
              list={synthesizeInfo.recommendations}
            />
            <ResultCard
              score={actScore}
              title={act.title}
              rating={actInfo.title}
              summary={actInfo.summary}
              list={actInfo.recommendations}
            />
            <ResultCard
              score={adaptScore}
              title={adapt.title}
              rating={adaptInfo.title}
              summary={adaptInfo.summary}
              list={adaptInfo.recommendations}
            />
          </Grid>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.header``

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`

const Grid = styled(ColumnTrack)`
  gap: 40px;
`

export default Results
